import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { PropertyDexie } from 'src/app/models/property.model';
import { CustomValidators } from 'src/app/_helpers/customValidators';

export interface CreatePropertyResult {
  createProperty:boolean,
  property:PropertyDexie
}

@Component({
    selector: 'app-create-property',
    templateUrl: './create-property.component.html',
    styleUrls: ['./create-property.component.css'],
    standalone: true,
    imports:[ReactiveFormsModule, MatDialogModule]
})
export class CreatePropertyComponent implements OnInit {
  dialogRef = inject<MatDialogRef<CreatePropertyComponent>>(MatDialogRef);
  property = inject<PropertyDexie>(MAT_DIALOG_DATA);


  data: CreatePropertyResult = {
    property:null,
    createProperty: false
  }

  createPropertyForm: UntypedFormGroup;

ngOnInit(): void {
  this.dialogRef.disableClose = true;

  this.createPropertyForm = new UntypedFormGroup(
    {
    'name': new UntypedFormControl(null, CustomValidators.required),
    'notes': new UntypedFormControl(null)
    },
  );

}
    submit(){
      Object.assign(this.property, this.createPropertyForm.value);

      this.dialogRef.close(this.property);
    }

}
